var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-form-section",style:({ width: _vm.width })},[_c('h2',{staticClass:"the-form-section__title"},[_vm._v(_vm._s(_vm.title))]),_c('main',{staticClass:"the-form-section__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }